// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:46:39

export default {
  "id": "stickman-in-space",
  "slug": "stickman-in-space",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/edc2ee4809284028b9287b6a011df09e-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/edc2ee4809284028b9287b6a011df09e/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stickman in space",
      "description": "You have to play as a Stickman astronaut who is stuck on the moon.\nUse all possible ways to leave the moon and get to our planet Earth.\nOn the way you will encounter various dangers, such as aliens, flying meteorites and much more.\nYou will have several objects in your hands with which you can try to escape from the natural satellite of the moon. Several objects will lead you to death, and some objects can save your life, be careful and cautious.\n",
      "instructions": "Find two successful ways to escape from the Moon.\nUse your computer mouse to control the game. If you have a mobile device, use a stylus or your finger.",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2d",
        "escape",
        "jailbreak",
        "stick",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "太空stickman",
      "description": "你必须扮演一名被困在月球上的木棍宇航员。\n使用所有可能的方式离开月球并回到我们所在的地球。\n途中，你将遇到各种危险，如外星人、飞行的陨石等等。\n你手中将会有几个物品，你可以用它们尝试逃离月球这颗天然卫星。一些物品会带你走向死亡，而有些物品则可能拯救你的生命，小心谨慎。",
      "instructions": "找到两种逃离月球的成功方法。\n使用电脑鼠标控制游戏。如果您有移动设备，请使用触笔或手指。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "2D",
        "逃脱",
        "越狱",
        "棍子",
        "小棍人"
      ]
    },
    "zh-TW": {
      "title": "太空中的粘土人",
      "description": "您必須扮演一名卡通宇航員，他被困在月球上。\n使用所有可能的方式離開月球並回到我們的地球。\n在旅途中，您將遇到各種危險，例如外星人、飛行流星等等。\n您將手持多種物品，試圖從月球這個自然衛星中逃脫。有些物品會讓您送命，而有些物品則可能拯救您的生命，請小心謹慎。",
      "instructions": "尋找兩種成功逃離月球的辦法。\n使用電腦滑鼠操控遊戲。如果您有行動裝置，請使用筆或手指。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "逃脫",
        "越獄",
        "棒子",
        "棒人"
      ]
    },
    "zh-HK": {
      "title": "太空人偶",
      "description": "你必須扮演一名卡牌太空人，他被困在月球上。\n盡一切可能的方法離開月球並回到我們的地球。\n在旅途中，你將遇到各種危險，如外星人、飛行的流星等。\n你將手握多個物件，可用來試圖從月球的天然衛星中逃脫。一些物件將導致你死亡，而一些物件則可以拯救你的生命，小心並謹慎。",
      "instructions": "尋找兩種逃離月球的成功方法。\n使用電腦滑鼠控制遊戲。如果您有行動裝置，請使用筆或手指。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2D",
        "逃脫",
        "釋囚",
        "木棒",
        "小人仔"
      ]
    },
    "ja": {
      "title": "宇宙のストックマン",
      "description": "月に捕らわれた棒人間としてプレイしなければなりません。\nどんな方法でも使って月を離れ、地球に戻ることができます。\nその道のりで、宇宙人、飛び散る隕石など、さまざまな危険に直面します。\n手に持っているさまざまな物を使って、月の天然衛星から逃げ出すことを試みましょう。いくつかの物は死に至るものですが、他の物は命を救うこともあります。慎重に行動し、注意を払ってください。",
      "instructions": "月から逃げ出すための2つの成功方法を見つけなさい。コンピュータのマウスを使ってゲームを操作します。モバイルデバイスをお使いの場合は、スタイラスや指を使用してください。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2D",
        "脱出",
        "脱獄",
        "棒",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "스틱맨 인 스페이스",
      "description": "달에 갇힌 Stickman 우주인으로서, 달을 떠나 지구로 돌아가는 모든 방법을 사용해야 합니다.\n그 과정에서 외星人, 날아다니는 화성유체와 같은 다양한 위험에 직면하게 됩니다.\n손에 들고 있는 여러 가지 물체로 달의 자연 위성에서 탈출을 시도해보세요. 일부 물체는 죽음으로 이어질 수 있으며, 일부 물체는 생명을 구할 수 있습니다. 조심스럽고 주의 깊게하세요.",
      "instructions": "달에서 탈출하는 두 가지 성공적인 방법을 찾아보세요. 컴퓨터 마우스로 게임을 제어하세요. 모바일 기기를 사용하는 경우 펜슬이나 손가락을 사용하세요.",
      "genres": [
        "모험"
      ],
      "tags": [
        "2D",
        "탈출",
        "탈옥",
        "스티크",
        "스티커맨"
      ]
    },
    "fr": {
      "title": "Homme en stick dans l'espace",
      "description": "Vous devez jouer en tant qu'astronaute Stickman coincé sur la Lune.\nUtilisez toutes les méthodes possibles pour quitter la Lune et vous rendre sur notre planète Terre.\nEn route, vous rencontrerez divers dangers, tels que des extraterrestres, des météores volants et bien plus encore.\nVous aurez plusieurs objets en main avec lesquels vous pouvez tenter de vous échapper de la lune naturelle. Certains objets vous mèneront à la mort, tandis que d'autres peuvent vous sauver la vie, soyez prudent et vigilant.",
      "instructions": "Trouvez deux méthodes réussies pour fuir la Lune.\nUtilisez votre souris d'ordinateur pour contrôler le jeu. Si vous avez un appareil mobile, utilisez un stylet ou votre doigt.",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2D",
        "évasion",
        "jailbreak",
        "pique",
        "piquemaniac"
      ]
    }
  }
};
